var routeList = [
    "/search",
    "/edis",
    // "/markets/futures",
    // "/markets/options",
    "/fund-transfer",
];
export var chatBotManager = function (route, isSidebar) {
    var result = true;
    if (isSidebar) {
        return (result = false);
    }
    else {
        return (result = routeList.includes(route) ? false : true);
    }
};
